(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-campaign-bar"] && !Shopify.designMode) return;
  try {
    
(function(){function refresh(){document.querySelectorAll('[data-mm-kg-bar]').forEach(function(el){var active=Date.now()>=Date.parse(el.dataset.start)&&Date.now()<Date.parse(el.dataset.end);el.hidden=!active;var fallback=el.nextElementSibling;if(fallback&&fallback.hasAttribute('data-mm-kg-bar-fallback'))fallback.hidden=active;});}refresh();document.addEventListener('shopify:section:load',refresh);setInterval(refresh,15000);})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-customer-reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mm-review-proof')) {
  customElements.define('mm-review-proof', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      const library = this.querySelector('.mm-review-library');
      if (!library) return;
      const records = new Map();
      const create = (tag, className, text) => {
        const element = document.createElement(tag);
        if (className) element.className = className;
        if (text != null) element.textContent = text;
        return element;
      };
      let recent = {};
      try { recent = JSON.parse(this.querySelector('[data-mm-recent-reviews]')?.textContent || '{}'); } catch {}
      const knownIds = new Set([...library.querySelectorAll('[data-review-id]')].map(e=>e.dataset.reviewId));
      const decodeText = text => { const element=document.createElement('textarea'); element.innerHTML=text||''; return element.value; };
      [...(recent.all_reviews||[]),...(recent.product_reviews||[]),...(recent.shop_reviews||[])].forEach(item => {
        if (knownIds.has(item.uuid)) return;
        knownIds.add(item.uuid);
        const review=create('div','jdgm-rev');
        review.dataset.reviewId=item.uuid;
        review.dataset.verifiedBuyer=String(item.verified_buyer===true);
        const header=create('div','jdgm-rev__header');
        const author=create('span','jdgm-rev__author-wrapper');
        author.append(create('span','jdgm-rev__author',item.is_anonymous_reviewer?'Anonymous':item.reviewer_name));
        const rating=create('span','jdgm-rev__rating');
        rating.setAttribute('role','img');
        rating.setAttribute('aria-label',item.rating+' / 5');
        for(let i=1;i<=5;i++) rating.append(create('span','jdgm-star '+(i<=item.rating?'jdgm--on':'jdgm--off')));
        const stamp=create('span','jdgm-rev__timestamp');
        stamp.dataset.content=item.created_at;
        header.append(author,rating,stamp);
        if(item.product_url?.startsWith('/products/')) {
          const product=create('span','jdgm-rev__prod-info-wrapper');
          const link=create('a','jdgm-rev__prod-link',decodeText(item.product_title));
          link.href=item.product_url;
          product.append(link);
          header.append(product);
        } else header.append(create('span','jdgm-rev__prod-info-wrapper',this.dataset.shopLabel));
        const content=create('div','jdgm-rev__content');
        if(item.title) content.append(create('b','jdgm-rev__title',item.title));
        const body=create('div','jdgm-rev__body');
        body.append(create('p','',item.body));
        body.style.whiteSpace='pre-line';
        content.append(body);
        const badge=create('div','jdgm-rev__transparency-badge');
        badge.dataset.badgeType=(item.transparency_badges||[])[0]||'';
        const badgeWrap=create('div','jdgm-rev__transparency-badge-wrapper');
        badgeWrap.append(badge);
        content.append(badgeWrap);
        review.append(header,content);
        library.append(review);
      });
      const dateFormat = new Intl.DateTimeFormat(document.documentElement.lang || 'en', {year:'numeric',month:'short',day:'numeric',timeZone:'UTC'});
      const proofLine = (verified, date, source) => {
        const line = document.createElement('div');
        line.className = 'mm-review-proofline';
        if (verified) {
          const badge = document.createElement('span');
          badge.className = 'mm-review-verified';
          badge.textContent = '✓ ' + this.dataset.verifiedLabel;
          line.append(badge);
        }
        if (date && !Number.isNaN(date.getTime())) {
          const time = document.createElement('time');
          time.dateTime = date.toISOString().slice(0,10);
          time.textContent = dateFormat.format(date);
          line.append(time);
        }
        if (source) {
          const provenance = document.createElement('span');
          provenance.textContent = source;
          line.append(provenance);
        }
        return line;
      };
      const reviews = [...library.querySelectorAll('.jdgm-rev[data-review-id]')];
      if (reviews.length === Number(this.dataset.total)) this.querySelector('.mm-review-details>summary').textContent=this.dataset.allLabel;
      reviews.forEach(review => {
        const stamp = review.querySelector('.jdgm-rev__timestamp');
        const rawDate = stamp?.dataset.content || '';
        const date = rawDate ? new Date(rawDate.replace(' UTC','Z').replace(' ','T')) : null;
        const verified = review.dataset.verifiedBuyer === 'true';
        const productLink = review.querySelector('.jdgm-rev__prod-link');
        const sourceType = review.querySelector('.jdgm-rev__transparency-badge')?.dataset.badgeType;
        const source = sourceType === 'review_written_in_shop_app' ? this.dataset.shopSource : sourceType === 'review_collected_via_store_invitation' ? this.dataset.inviteSource : '';
        const data = {verified,date,source,productLink};
        records.set(review.dataset.reviewId,data);
        review.id = 'mm-review-' + review.dataset.reviewId;
        review.querySelector('.jdgm-rev__header')?.append(proofLine(verified,date,source));
        if (productLink) {
          productLink.removeAttribute('target');
          productLink.hash = 'judgeme_product_reviews';
        }
      });
      reviews.sort((a,b)=>(records.get(b.dataset.reviewId).date?.getTime()||0)-(records.get(a.dataset.reviewId).date?.getTime()||0)).forEach(review=>library.append(review));
      const enrich = () => {
        this.querySelectorAll('.jdgm-carousel-item[data-review-id]').forEach(card => {
          if (card.dataset.mmProof) return;
          const data = records.get(card.dataset.reviewId);
          if (!data) return;
          card.dataset.mmProof = 'true';
          card.querySelector('.jdgm-carousel-item__reviewer-name-wrapper')?.append(proofLine(data.verified,data.date,''));
          const product = card.querySelector('.jdgm-carousel-item__product');
          if (!product) return;
          const text = document.createElement('div');
          const name = document.createElement(data.productLink ? 'a' : 'span');
          name.className = 'mm-review-product-title';
          name.textContent = data.productLink?.textContent.trim() || card.querySelector('.jdgm-carousel-item__product-image')?.alt || this.dataset.shopLabel;
          if (data.productLink) name.href = data.productLink.href;
          text.append(name);
          if (data.productLink) {
            const link = document.createElement('a');
            link.className = 'mm-review-read';
            link.href = data.productLink.href;
            link.textContent = this.dataset.readLabel;
            text.append(link);
          }
          product.append(text);
        });
      };
      enrich();
      const carousel = this.querySelector('.jdgm-carousel-wrapper');
      if (!carousel) return;
      let frame = null;
      let moving = false;
      let observedWrapper = null;
      const measure = () => {
        frame = null;
        const viewport = carousel.querySelector('.jdgm-carousel__item-container');
        if (!viewport) return;
        const bounds = viewport.getBoundingClientRect();
        let height = 0;
        carousel.querySelectorAll('.jdgm-carousel-item').forEach(card => {
          const rect = card.getBoundingClientRect();
          if (Math.min(rect.right, bounds.right) - Math.max(rect.left, bounds.left) > 2) height = Math.max(height, rect.height);
        });
        const value = Math.ceil(height) + 'px';
        if (height > 0 && viewport.style.getPropertyValue('--mm-review-height') !== value) viewport.style.setProperty('--mm-review-height', value);
        if (moving) frame = requestAnimationFrame(measure);
      };
      const queueMeasure = () => { if (frame === null) frame = requestAnimationFrame(measure); };
      const resize = new ResizeObserver(queueMeasure);
      const sync = () => {
        enrich();
        const wrapper = carousel.querySelector('.jdgm-carousel__item-wrapper');
        if (wrapper && wrapper !== observedWrapper) {
          resize.disconnect();
          resize.observe(wrapper);
          observedWrapper = wrapper;
        }
        queueMeasure();
      };
      const onTransition = event => {
        if (!event.target.matches('.jdgm-carousel__item-wrapper') || event.propertyName !== 'transform') return;
        moving = event.type === 'transitionrun';
        queueMeasure();
      };
      ['transitionrun', 'transitionend', 'transitioncancel'].forEach(type => carousel.addEventListener(type, onTransition));
      this.proofObserver = new MutationObserver(changes => {
        if (changes.some(change => change.type === 'childList')) sync();
        else if (changes.some(change => change.target.matches('.jdgm-carousel__item-wrapper'))) queueMeasure();
      });
      this.proofObserver.observe(carousel,{childList:true,subtree:true,attributes:true,attributeFilter:['style']});
      this.cleanupReviewHeight = () => {
        if (frame !== null) cancelAnimationFrame(frame);
        resize.disconnect();
        ['transitionrun', 'transitionend', 'transitioncancel'].forEach(type => carousel.removeEventListener(type, onTransition));
      };
      sync();
    }
    disconnectedCallback() { this.proofObserver?.disconnect(); this.cleanupReviewHeight?.(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-taste-finder"] && !Shopify.designMode) return;
  try {
    
function mmSetupFinder(scope) {
  scope.querySelectorAll('[data-mm-finder]').forEach(root => {
    if (root.dataset.mmReady) return;
    root.dataset.mmReady = 'true';
    const choices = root.querySelector('.mm-find__choices');
    const buttons = root.querySelectorAll('[data-mm-choice]');
    const panels = root.querySelectorAll('[data-mm-panel]');
    function choose(value) {
      buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.mmChoice === value)));
      panels.forEach(panel => panel.hidden = panel.dataset.mmPanel !== value);
    }
    buttons.forEach(button => button.addEventListener('click', () => choose(button.dataset.mmChoice)));
    choices.hidden = false;
    choose('water');
  });
}
mmSetupFinder(document);
document.addEventListener('shopify:section:load', event => mmSetupFinder(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-ten-sakura-week"] && !Shopify.designMode) return;
  try {
    
(function(){function refresh(){document.querySelectorAll('[data-mm-kg-end]').forEach(function(el){if(Date.now()>=Date.parse(el.dataset.mmKgEnd))el.hidden=true;});}refresh();document.addEventListener('shopify:section:load',refresh);setInterval(refresh,15000);})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-visual-entry"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mm-sakura-video')) {
  customElements.define('mm-sakura-video', class extends HTMLElement {
    connectedCallback() {
      if (this.resetPlayer) return;
      const video = this.querySelector('video');
      const button = this.querySelector('.mft__play');
      if (!video || !button) return;
      const label = button.querySelector('[data-button-label]');
      const icon = button.querySelector('.mft__play-icon');
      const photoCaption = this.querySelector('[data-photo-caption]');
      const videoCaption = this.querySelector('[data-video-caption]');
      const status = this.querySelector('.mft__video-status');
      const fallbackLink = this.querySelector('[data-video-fallback]');
      let mode = 'poster';
      let needsLoad = true;
      let attempt = 0;
      let startupTimer;
      let frameRequest;
      const clearPending = () => {
        clearTimeout(startupTimer);
        if (frameRequest !== undefined) cancelAnimationFrame(frameRequest);
        frameRequest = undefined;
        button.disabled = false;
        button.removeAttribute('aria-busy');
      };
      const showStatus = (message) => {
        status.textContent = message;
        status.hidden = !message;
      };
      const reset = (failed = false) => {
        attempt += 1;
        mode = 'poster';
        clearPending();
        video.pause();
        delete video.dataset.visible;
        video.setAttribute('aria-hidden', 'true');
        video.setAttribute('tabindex', '-1');
        photoCaption.hidden = false;
        videoCaption.hidden = true;
        label.textContent = button.dataset.play;
        icon.textContent = '▶';
        if (failed) needsLoad = true;
        fallbackLink.hidden = !failed;
        showStatus(failed ? this.dataset.error : '');
      };
      this.resetPlayer = reset;
      button.hidden = false;
      video.addEventListener('playing', () => {
        if (video.paused || video.ended || mode === 'poster') return;
        const currentAttempt = attempt;
        const showFrame = () => {
          if (currentAttempt !== attempt || video.paused || video.ended || video.readyState < 2 || !video.videoWidth) return;
          mode = 'playing';
          clearPending();
          video.dataset.visible = 'true';
          video.removeAttribute('aria-hidden');
          video.setAttribute('tabindex', '0');
          photoCaption.hidden = true;
          videoCaption.hidden = false;
          label.textContent = button.dataset.pause;
          icon.textContent = 'Ⅱ';
          showStatus('');
        };
        frameRequest = requestAnimationFrame(showFrame);
      });
      video.addEventListener('pause', () => {
        if (mode === 'poster') return;
        attempt += 1;
        clearPending();
        mode = video.dataset.visible === 'true' ? 'paused' : 'poster';
        label.textContent = mode === 'paused' ? button.dataset.resume : button.dataset.play;
        icon.textContent = '▶';
        showStatus('');
      });
      video.addEventListener('ended', () => reset());
      video.addEventListener('error', () => reset(true));
      button.addEventListener('click', () => {
        if (mode === 'loading') return;
        if (!video.paused && !video.ended) {
          video.pause();
          return;
        }
        const currentAttempt = ++attempt;
        mode = 'loading';
        fallbackLink.hidden = true;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        label.textContent = this.dataset.loading;
        icon.textContent = '…';
        showStatus(this.dataset.loading);
        startupTimer = setTimeout(() => {
          if (currentAttempt === attempt) reset(true);
        }, 15000);
        try {
          video.muted = true;
          video.defaultMuted = true;
          video.playsInline = true;
          if (needsLoad || video.error) {
            video.load();
            needsLoad = false;
          }
          const playback = video.play();
          if (playback && playback.catch) {
            playback.catch(() => {
              if (currentAttempt === attempt) reset(true);
            });
          }
        } catch (_) {
          if (currentAttempt === attempt) reset(true);
        }
      });
    }
    disconnectedCallback() {
      if (this.resetPlayer) this.resetPlayer();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
